module.exports = __webpack_public_path__ + "static/img/互动投影new.aea27682.png";